import React, { useState, useEffect } from "react";
import UploadSpareImgService from "../../services/UploadSpareImgService";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import SparePhotoById from "../../services/SparePhotoById";
import DeleteSpareImgService from "../../services/DeleteSpareImgService";
import SparePhotoPreview from "../../services/SparePhotoPreview";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import DetailsIcon from "@mui/icons-material/Details";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { GridCloseIcon } from "@mui/x-data-grid";
import {
  Box,
  Container,
  Divider,
  Grid,
  Paper,
  Button,
  MenuItem,
  Menu,
  Typography,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import useGlobalState from "../../Context";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const SparePhotos = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  //const baseUrl = 'https://spms.dev.ril.com';
  const [image, setImage] = useState({ preview: "", raw: "" });
  const [selectedFile, setSelectedFile] = useState(null);
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [detailData, setDetailData] = useState("");
  const [photo1Url, setPhoto1Url] = useState(false);
  const [isphotoEdit, setPhotoEdit] = useState(false);
  const [editNum, setEditNum] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [slcRow, setSlcRow] = React.useState(null);
  const [photoRowData, setPhotoRowData] = React.useState(null);
  const [explodedImageDialog, setExplodedImageDialog] = useState(false);
  const [deleteImageDialog, setDeleteImageDialog] = useState(false);
  const [deleteNum, setDeleteNum] = useState("");
  const [artCode, setArtCode] = useState("");
  const [artDesc, setArtDesc] = useState("");
  const [explodedImageSrc, setExplodedImageSrc] = useState("/");
  const [imgUrl, setImgUrl] = useState();
  const [imgUrl2, setImgUrl2] = useState();
  const [diableUploadButton, setDisableUploadButton] = useState(true);
  const navigate = useNavigate();
  const id = useParams();
  const inputFileRef = React.useRef();
  const open = Boolean(anchorEl);
  const [{ auth, spareAccessRights }, dispatch] = useGlobalState();
  const handleExploredImageDialogClose = () => {
    setExplodedImageDialog(false);
  };
  const handleExplodedImageDialogOpen = (src) => {
    setExplodedImageDialog(true);
    setExplodedImageSrc(src);
  };
  const handleDeleteImageDialogOpen = () => {
    setDeleteImageDialog(true);
  };
  const handleDeleteImageDialogClose = () => {
    setDeleteImageDialog(false);
  };
  const handleClick = (event, row, photoData) => {
    setAnchorEl(event.currentTarget);
    setSlcRow(row);
    setPhotoRowData(photoData);
  };
  const handlPhotoAction = (e, photoSerial, photoNum, itemAction) => {
    setAnchorEl(null);
    if (itemAction === "edit") {
      if (slcRow == 1) {
        handleClickEdit(1);
      } else {
        handleClickEdit(2);
      }
    } else if (itemAction === "delete") {
      if (slcRow == 1) {
        handleDeleteImageDialogOpen();
        setDeleteNum(1);
      } else {
        handleDeleteImageDialogOpen();
        setDeleteNum(2);
      }
    } else if (itemAction === "download") {
      if (slcRow == 1) {
        handleClickDownload(photoRowData?.photo1ActualName);
      } else {
        handleClickDownload(photoRowData?.photo2ActualName);
      }
    } else {
      console.log("error in photo action listing menu");
    }
  };
  //const navigate = useNavigate();
  const { state } = useLocation();
  useEffect(() => {
    detailById(parseInt(state?.spareId));
    setArtCode(state?.code);
    setArtDesc(state?.description);
  }, []);

  const goBack = () => {
    navigate("/spare-search");
  };

  const handleClickEdit = async (num) => {
    setEditNum(num);
    setPhotoEdit(true);
    inputFileRef.current.click();
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleClickDlt = async (num) => {
    try {
      const param = {
        num: num,
        spareId: parseInt(state?.spareId),
      };
      const response = await DeleteSpareImgService(baseUrl, param);
      if (response.statusCode === 6) {
        setDeleteImageDialog(false);
        showNotification("Success", "Sucessfully Deleted", "success");
        detailById(parseInt(state?.spareId));
      } else {
        showNotification("Error", response.message, " error");
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to Delete");
     // console.log('catch err',err)
    } finally {
      //setLoading(false);
    }
  };
  const handleClickDownload = async (fileName) => {
    try {
      setLoading(true);
      const param = {
        spareId: parseInt(state?.spareId),
        fileName: fileName,
        code: artCode,
        description: artDesc,
      };
      const response = await SparePhotoPreview(
        baseUrl,
        param.spareId,
        param.fileName,
        param
      );
      if (response) {
        const a = document.createElement("a");
        a.download = `${artCode}-${artDesc}.jpg`;
        a.href = `data:image/png;base64,${response.data.response}`;
        a.click();
      } else {
        showNotification(
          "Info",
          response?.message ?? "Failed to download spare photo else"
        );
      }
    } catch (err) {
      console.log("errr", err);
      showNotification("Error", "Failed to download spare photo cach");
    } finally {
      setLoading(false);
    }
  };
  const detailById = async (id) => {
    try {
      // setLoading(true);
      const param = {
        spareId: parseInt(state?.spareId),
      };
      const detailResp = await SparePhotoById(baseUrl, parseInt(state?.spareId), param);
      if (detailResp.statusCode === 6) {
        if (detailResp?.data.photo1ActualName) {
          const responseImage = await prevPhotoBId(
            parseInt(state?.spareId),
            detailResp?.data.photo1ActualName
          );
          setImgUrl(responseImage);
        }
        if (detailResp?.data.photo2ActualName) {
          const responseImage = await prevPhotoBId(
            parseInt(state?.spareId),
            detailResp?.data.photo2ActualName
          );
          setImgUrl2(responseImage);
        }
        setDetailData(detailResp.data);
        if (detailResp?.data.photo1ActualName) {
          setPhoto1Url(true);
        } else {
          setPhoto1Url(false);
        }
      } else {
        showNotification(
          "Error",
          detailResp?.message ?? "Failed to fetch spare photo data"
        );
      }
    } catch (err) {
      // console.log("errrr", err);
      //showNotification("Error", "Failed to fetch spare photo data cache");
    } finally {
      // setLoading(false);
    }
  };

  const prevPhotoBId = async (id, fileName) => {
    try {
      // setLoading(true);
      //const param = id.spareId;
      const param = {
        spareId: parseInt(state?.spareId),
        fileName: fileName,
      };
      const detailResp = await SparePhotoPreview(
        baseUrl,
        param.spareId,
        param.fileName,
        param
      );
      // setImgUrl(detailResp.response)
      if (detailResp.data.response) {
        return detailResp.data.response;
      } else {
        showNotification(
          "Info",
          detailResp?.message ?? "Failed to fetch spare photo data"
        );
      }
    } catch (err) {
      console.log("errrr cath", err);
      showNotification("Error", "Failed to fetch spare photo data");
    } finally {
      // setLoading(false);
    }
  };

  const handleChange = (event) => {
    if (
      event.target.files === null ||
      event.target.files === undefined ||
      event.target.files.length === 0
    ) {
      setImage({
        preview: "",
        raw: "",
      });
      setDisableUploadButton(true);
    } else {
      var pattern = /image-*/;
      if (!event?.target?.files[0]?.type?.match(pattern)) {
        showNotification("Error", "Invalid type selected, Please try again.");
        setImage({
          preview: "",
          raw: "",
        });
        inputFileRef.current.value = "";
      } else {
        if (event.target.files[0].size >= 10485760) {
          // allowing only file less than 10mbs
          showNotification(
            "Error",
            "File too Big, please select a file less than 10mb"
          );
          setImage({
            preview: "",
            raw: "",
          });
          inputFileRef.current.value = "";
        } else {
          setImage({
            preview: URL.createObjectURL(event.target.files[0]),
            raw: event.target.files[0],
          });
          setDisableUploadButton(false);
          setSelectedFile(event.target.files[0]);
        }
      }
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();

    //const formData = new FormData();
    try {
      setLoading(true);
      const param = {
        num: photo1Url ? 2 : 1,
        spareId: parseInt(state?.spareId),
        createdBy: auth?.ldapParam?.userId,
      };
      const uploadResponse = await UploadSpareImgService(
        baseUrl,
        selectedFile,
        param
      );
      if (uploadResponse.statusCode === 6) {
        detailById(parseInt(state?.spareId));
        setImage({
          preview: "",
          raw: "",
        });
        setDisableUploadButton(true);
        setSelectedFile(null);
        showNotification("Success", uploadResponse?.message, "success");
      } else {
        //console.log('reject')
        showNotification("Error", uploadResponse?.message, "error");
      }
    } catch (err) {
      console.log("errrr", err);
      //showNotification("Error", err?.message ?? "Failed to Get Case Config");
    } finally {
      setLoading(false);
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    //const formData = new FormData();
    try {
      //setLoading(true);
      const param = {
        num: editNum,
        spareId:parseInt(state?.spareId),
        createdBy: auth?.ldapParam?.userId,
      };
      const uploadResponse = await UploadSpareImgService(
        baseUrl,
        selectedFile,
        param
      );
      if (uploadResponse.statusCode == "6") {
        detailById(parseInt(state?.spareId));
        setImage({
          preview: "",
          raw: "",
        });
        setSelectedFile(null);
        setPhotoEdit(false);
        setDisableUploadButton(true);
        setEditNum(null);
        showNotification("Success", uploadResponse?.message, "success");
      } else {
        //console.log("reject");
        showNotification("Error", uploadResponse?.message, "error");
      }
    } catch (err) {
      console.log("errrr", err);
      //showNotification("Error", err?.message ?? "Failed to Get Case Config");
    } finally {
      //setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 8 }}>
        <Grid container sx={{ px: 3, mt: 1 }}>
          <Grid item xs={12} sx={{ mb: 3 }}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#567aac" }}
              variant="h6"
            >
              <IconButton sx={{ color: "#003f93" }}>
                <ArrowBackIcon onClick={goBack} />
              </IconButton>
              Article Code: {artCode} and Description: {artDesc}
            </Typography>
          </Grid>
        </Grid>
        <Paper
          elevation={4}
          sx={{ width: "96%", overflow: "hidden", ml: "20px" }}
        >
          <ImageNotificationDialog
            src={explodedImageSrc}
            open={explodedImageDialog}
            handleClose={handleExploredImageDialogClose}
          />

          <Grid container spacing={2} sx={{ px: 3, mt: 1 }}>
            <Grid item xs={3}>
              <label htmlFor="upload-button">
                {image.preview ? (
                  <img
                    src={image.preview}
                    alt="dummy"
                    width="200"
                    height="200"
                  />
                ) : (
                  <></>
                )}
              </label>
            </Grid>
            {spareAccessRights.addDelete ? (
              <Grid
                item
                xs={9}
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  id="upload-button"
                  accept="image/png, image/jpg, image/jpeg"
                  ref={inputFileRef}
                  style={{ width: "240px" }}
                  onChange={handleChange}
                />
                <br />
                <Button
                  variant="contained"
                  onClick={isphotoEdit ? handleUpdate : handleUpload}
                  disabled={diableUploadButton}
                >
                  Upload
                </Button>
              </Grid>
            ) : null}
          </Grid>
          <Grid
            container
            direction="row"
            spacing={2}
            sx={{ mt: 4, px: 3, mb: 2 }}
          >
            {detailData?.photo1ActualName ? (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ borderRight: "1px solid #cccccc" }}
              >
                <Grid container spacing={2} xs={{ px: 3 }}>
                  <Grid item xs={1} md={1}></Grid>
                  <Grid item xs={9} md={9} sx={{ cursor: "pointer" }}>
                    <ul className="photoField">
                      <li>
                        Photo Name : {detailData?.photo1ActualName ?? "-"}
                      </li>
                    </ul>
                    <img
                      className="w-100"
                      alt="upload"
                      src={"data:image/png;base64," + imgUrl}
                      height="200"
                      onClick={() => handleExplodedImageDialogOpen(imgUrl)}
                    />
                  </Grid>
                  <Grid item xs={2} md={2} sx={{ mt: "10px" }}>
                    <MoreVertIcon
                      //className="profileEdit"
                      color="primary"
                      onClick={(event) => {
                        handleClick(event, "1", detailData);
                      }}
                      fontSize="small"
                      cursor="pointer"
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseMenu}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      {spareAccessRights.write ? (
                        <MenuItem
                          onClick={(e) => {
                            handlPhotoAction(e, "photo1", "1", "edit");
                          }}
                        >
                          <EditIcon
                            fontSize="medium"
                            color="disabled"
                            sx={{ mr: 1 }}
                          />
                          Edit
                        </MenuItem>
                      ) : null}
                      {spareAccessRights.addDelete ? (
                        <MenuItem
                          onClick={(e) => {
                            handlPhotoAction(e, "photo1", "1", "delete");
                          }}
                        >
                          <DetailsIcon
                            fontSize="medium"
                            color="disabled"
                            sx={{ mr: 1 }}
                          />
                          Delete
                        </MenuItem>
                      ) : null}
                      {auth?.ldapParam?.rilUser ? (
                        <MenuItem
                          onClick={(e) => {
                            handlPhotoAction(e, "photo1", "1", "download");
                          }}
                        >
                          <AddPhotoAlternateIcon
                            fontSize="medium"
                            color="disabled"
                            sx={{ mr: 1 }}
                          />
                          Download
                        </MenuItem>
                      ) : null}
                    </Menu>
                  </Grid>
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            {detailData?.photo2ActualName ? (
              <Grid
                item
                xs={12}
                md={6}
                sx={{ borderLeft: "1px solid #cccccc" }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={9} md={9} sx={{ cursor: "pointer" }}>
                    <ul className="photoField">
                      <li>
                        Photo Name : {detailData?.photo2ActualName ?? "-"}
                      </li>
                    </ul>
                    <img
                      className="w-100"
                      alt="upload"
                      src={"data:image/png;base64," + imgUrl2}
                      height="200"
                      onClick={() => handleExplodedImageDialogOpen(imgUrl2)}
                    />
                  </Grid>
                  <Grid item xs={2} md={2} sx={{ mt: "10px" }}>
                    <MoreVertIcon
                      //className="profileEdit"
                      color="primary"
                      onClick={(event) => {
                        handleClick(event, "2", detailData);
                      }}
                      fontSize="small"
                      cursor="pointer"
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleCloseMenu}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      {spareAccessRights.write ? (
                        <MenuItem
                          onClick={(e) => {
                            handlPhotoAction(e, "photo2", "2", "edit");
                          }}
                        >
                          <EditIcon
                            fontSize="medium"
                            color="disabled"
                            sx={{ mr: 1 }}
                          />
                          Edit
                        </MenuItem>
                      ) : null}
                      {spareAccessRights.addDelete ? (
                        <MenuItem
                          onClick={(e) => {
                            handlPhotoAction(e, "photo2", "2", "delete");
                          }}
                        >
                          <DetailsIcon
                            fontSize="medium"
                            color="disabled"
                            sx={{ mr: 1 }}
                          />
                          Delete
                        </MenuItem>
                      ) : null}
                      {auth?.ldapParam?.rilUser ? (
                        <MenuItem
                          onClick={(e) => {
                            handlPhotoAction(e, "photo2", "2", "download");
                          }}
                        >
                          <AddPhotoAlternateIcon
                            fontSize="medium"
                            color="disabled"
                            sx={{ mr: 1 }}
                          />
                          Download
                        </MenuItem>
                      ) : null}
                    </Menu>
                  </Grid>
                  <Grid item xs={1} md={1}></Grid>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        </Paper>
      </Container>

      <Dialog
        open={deleteImageDialog}
        onClose={handleDeleteImageDialogClose}
        maxWidth="xs"
      >
        <DialogTitle
          color="error"
          sx={{
            backgroundColor: "#003f93",
            color: "#ffffff",
            fontSize: "16px",
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>Photo Delete</div>
            <GridCloseIcon
              className="pageHeader"
              onClick={handleDeleteImageDialogClose}
              style={{ cursor: "pointer", color: "white" }}
            />
          </Box>
        </DialogTitle>
        <Divider />
        <Grid container className="bg-white">
          <Grid item xs={12} md={12}>
            <Grid item xs={12} md={12} sx={{ p: 3 }}>
              <Box>Are you sure to delete this photo?</Box>
            </Grid>
            <Divider />
            <React.Fragment>
              <Box
                sx={{ display: "flex", flexDirection: "row", p: 1.5, pl: 23 }}
              >
                <Button
                  variant="outlined"
                  onClick={handleDeleteImageDialogClose}
                  sx={{ mr: 1 }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  onClick={() => handleClickDlt(deleteNum)}
                  sx={{ mr: 1 }}
                  variant="contained"
                  className="button-primary-alt-contained"
                >
                  Delete
                </Button>
                <Box sx={{ flex: "1 1 auto" }} />
              </Box>
            </React.Fragment>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

const ImageNotificationDialog = ({ open, handleClose, src }) => {
  const [artCode, setArtCode] = useState("");
  const [artDesc, setArtDesc] = useState("");
  const { state } = useLocation();
  useEffect(() => {
    setArtCode(state?.code);
    setArtDesc(state?.description);
  }, []);

  return (
    <Dialog fullWidth={true} open={open} onClose={handleClose}>
      <DialogTitle className="DialogTitle1">
        <GridCloseIcon
          className="pageHeader"
          onClick={handleClose}
          sx={{
            cursor: "pointer",
            color: "white",
            float: "right",
            marginLeft: "5px",
          }}
        />{" "}
        Exploded View ({artCode} - {artDesc})
      </DialogTitle>

      <Box
        style={{
          height: "100%",
          display: "inline-block",
          overflow: "none",
          textAlign: "center",
          margin: "0 auto",
          mt: "15px",
        }}
      >
        <TransformWrapper initialScale={1}>
          {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
            <>
              <TransformComponent>
                <Box
                  component="img"
                  sx={{
                    mt: 2,
                    height: 350,
                    width: 480,
                    objectFit: "contain",
                  }}
                  src={`data:image/png;base64,${src}`}
                />
              </TransformComponent>
              <Box className="tools" sx={{ mt: 3, mb: "20px" }}>
                <Tooltip title="Zoom In">
                  <IconButton onClick={() => zoomIn()}>
                    <AddCircleIcon />
                  </IconButton>
                </Tooltip>
                Zoom
                <Tooltip title="Zoom Out">
                  <IconButton onClick={() => zoomOut()}>
                    <DoDisturbOnIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Reset to default">
                  <IconButton onClick={() => resetTransform()}>
                    <RestartAltIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </>
          )}
        </TransformWrapper>
      </Box>
    </Dialog>
  );
};

export default SparePhotos;
